
'use strict';

define('lib/Podio.UI.Gifs',['require','lib/prototype/String.prototype','jquery','lib/Podio.Utils','models/Podio.Models.User'],function (require) {

  require('lib/prototype/String.prototype');

  var $ = require('jquery');
  var podioUtils = require('lib/Podio.Utils');
  var UserModel = require('models/Podio.Models.User');

  var toggleGif = function toggleGif(element) {
    var $target = $(element.target);

    var whichSrc = function whichSrc() {
      if ($target.attr('src') === $target.attr('static-src')) {
        return $target.attr('animated-src');
      }
      return $target.attr('static-src');
    };

    $target.attr('src', whichSrc()).parent().toggleClass('paused-gif playing-gif');
  };

  var pauseGifs = function pauseGifs(parentElem) {
    var userModel = new UserModel();

    if (userModel.getProperty('pause_gifs_on_load') && podioUtils.showFeature('gif_pause')) {
      parentElem = parentElem || $('body');
      $(parentElem).find('img').each(function (t) {
        var staticSrc = undefined;
        var animatedSrc = $(this).attr('src');
        if ($(this).hasClass('loading-animated-gif') && !$(this).parent().hasClass('gif-wrapper')) {
          $(this).removeClass('loading-animated-gif').bind('click', toggleGif).wrap('<span class="gif-wrapper paused-gif"></span>');
        }
        // If we support gifs from other sources we would assign static sources here
        else if (animatedSrc.match(/giphy.com/) && !$(this).parent().hasClass('gif-wrapper')) {
            staticSrc = animatedSrc.replace(/_d.gif$|.gif$/, '_s.gif');
            $(this).attr('static-src', staticSrc).attr('animated-src', animatedSrc).attr('src', staticSrc).bind('click', toggleGif).wrap('<span class="gif-wrapper paused-gif"></span>');
          }
      });
    }
  };

  return {
    pauseGifs: pauseGifs
  };
});
